const UnApprove = "UnApprove"
const Approve = "Approve"
const UnPublish = "UnPublish"
const Publish = "Publish"
const GetSnapshotObject = "GetSnapshotObject"
const EmbedSnapshotObject = "EmbedSnapshotObject"
const ResetMadeSelections = "ResetMadeSelections"
const EndSelections = "EndSelections"
const BeginSelections = "BeginSelections"
const CopyFrom = "CopyFrom"
const GetLinkedObjects = "GetLinkedObjects"
const SetChildArrayOrder = "SetChildArrayOrder"
const DestroyAllChildren = "DestroyAllChildren"
const DestroyChild = "DestroyChild"
const CreateChild = "CreateChild"
const GetChildInfos = "GetChildInfos"
const GetParent = "GetParent"
const GetChild = "GetChild"
const SelectHyperCubeContinuousRange = "SelectHyperCubeContinuousRange"
const MultiRangeSelectTreeDataValues = "MultiRangeSelectTreeDataValues"
const MultiRangeSelectHyperCubeValues = "MultiRangeSelectHyperCubeValues"
const RangeSelectHyperCubeValues = "RangeSelectHyperCubeValues"
const SelectPivotCells = "SelectPivotCells"
const SelectHyperCubeCells = "SelectHyperCubeCells"
const SelectHyperCubeValues = "SelectHyperCubeValues"
const Unlock = "Unlock"
const Lock = "Lock"
const DrillUp = "DrillUp"
const CollapseTop = "CollapseTop"
const CollapseLeft = "CollapseLeft"
const ExpandTop = "ExpandTop"
const ExpandLeft = "ExpandLeft"
const AcceptListObjectSearch = "AcceptListObjectSearch"
const AbortListObjectSearch = "AbortListObjectSearch"
const SearchListObjectFor = "SearchListObjectFor"
const SelectListObjectContinuousRange = "SelectListObjectContinuousRange"
const SelectListObjectAll = "SelectListObjectAll"
const SelectListObjectAlternative = "SelectListObjectAlternative"
const SelectListObjectExcluded = "SelectListObjectExcluded"
const SelectListObjectPossible = "SelectListObjectPossible"
const SelectListObjectValues = "SelectListObjectValues"
const ExportData = "ExportData"
const ClearSelections = "ClearSelections"
const GetInfo = "GetInfo"
const GetFullPropertyTree = "GetFullPropertyTree"
const SetFullPropertyTree = "SetFullPropertyTree"
const GetEffectiveProperties = "GetEffectiveProperties"
const GetProperties = "GetProperties"
const SetProperties = "SetProperties"
const ClearSoftPatches = "ClearSoftPatches"
const ApplyPatches = "ApplyPatches"
const GetHyperCubeBinnedData = "GetHyperCubeBinnedData"
const GetHyperCubeTreeData = "GetHyperCubeTreeData"
const GetHyperCubeContinuousData = "GetHyperCubeContinuousData"
const GetHyperCubeStackData = "GetHyperCubeStackData"
const GetHyperCubePivotData = "GetHyperCubePivotData"
const GetHyperCubeReducedData = "GetHyperCubeReducedData"
const GetHyperCubeData = "GetHyperCubeData"
const GetListObjectData = "GetListObjectData"
const GetLayout = "GetLayout"
export { GetLayout };
export { GetListObjectData };
export { GetHyperCubeData };
export { GetHyperCubeReducedData };
export { GetHyperCubePivotData };
export { GetHyperCubeStackData };
export { GetHyperCubeContinuousData };
export { GetHyperCubeTreeData };
export { GetHyperCubeBinnedData };
export { ApplyPatches };
export { ClearSoftPatches };
export { SetProperties };
export { GetProperties };
export { GetEffectiveProperties };
export { SetFullPropertyTree };
export { GetFullPropertyTree };
export { GetInfo };
export { ClearSelections };
export { ExportData };
export { SelectListObjectValues };
export { SelectListObjectPossible };
export { SelectListObjectExcluded };
export { SelectListObjectAlternative };
export { SelectListObjectAll };
export { SelectListObjectContinuousRange };
export { SearchListObjectFor };
export { AbortListObjectSearch };
export { AcceptListObjectSearch };
export { ExpandLeft };
export { ExpandTop };
export { CollapseLeft };
export { CollapseTop };
export { DrillUp };
export { Lock };
export { Unlock };
export { SelectHyperCubeValues };
export { SelectHyperCubeCells };
export { SelectPivotCells };
export { RangeSelectHyperCubeValues };
export { MultiRangeSelectHyperCubeValues };
export { MultiRangeSelectTreeDataValues };
export { SelectHyperCubeContinuousRange };
export { GetChild };
export { GetParent };
export { GetChildInfos };
export { CreateChild };
export { DestroyChild };
export { DestroyAllChildren };
export { SetChildArrayOrder };
export { GetLinkedObjects };
export { CopyFrom };
export { BeginSelections };
export { EndSelections };
export { ResetMadeSelections };
export { EmbedSnapshotObject };
export { GetSnapshotObject };
export { Publish };
export { UnPublish };
export { Approve };
export { UnApprove };